export enum PinnedPosition {
  NONE = 0,
  LEFT = 1,
  RIGHT = 2,
  VIRTUAL = 3,
}
